import NamedDto from 'modules/base/dto/NamedDto';

export class PiWriterFieldEditDto extends NamedDto {
	constructor() {
		super();

		/** @type {string} */
		this.type = null;

		/** @type {string} */
		this.tagName = null;

		/** @type {string} */
		this.expression = null;
	}

	/**
	 * @typedef {Object} _PiWriterFieldEditDtoProps
	 * @property {string} type
	 * @property {string} tagName
	 * @property {string} expression
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _PiWriterFieldEditDtoProps} PiWriterFieldEditDtoProps
	 */
	/**
	 *
	 * @param {PiWriterFieldEditDtoProps} props
	 * @returns {PiWriterFieldEditDto}
	 */
	setup(props) {
		super.setup(props);

		this.type = props.type;
		this.tagName = props.tagName;
		this.expression = props.expression;

		return this;
	}
}

export default PiWriterFieldEditDto;